import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { ErrorMessageState } from './error-message.state';
import { ErrorMessageStateModel } from './error-message.state-model';

@Injectable()
export class ErrorMessageSelectors {
  @Selector([ErrorMessageState])
  static hasErrors(state: ErrorMessageStateModel): boolean {
    return state.counter > 0;
  }
}
